import React from 'react';
import './Bio.css';
const Bio = () => {
    return (
        <div className="Bio">
          <p>Come join us to unlock hidden talents and be a part of the Digital Dialogue Mela
            <br/>
            <p className='scroll1'><b>Click on Arrow to  see events</b></p>
            
          </p>
          
      </div>
    );
};

export default Bio;